import { inject, Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { City } from '@zayan-erp/home-building';
import { API_CONFIG, ApiCallingV2Service, DropdownData } from '@zayan-erp/shared';

@Injectable({
  providedIn: 'root'
})
export class CityService {
  #http = inject(ApiCallingV2Service);
  #apiConfig = inject(API_CONFIG);
  baseUrl = this.#apiConfig.baseUrlV2;

  readCities(): Observable<City[]> {
    return this.#http.getData(`${this.baseUrl}/city`, { showLoader: true, showMessage: false });
  }

  readProvinces(countryId: string): Observable<DropdownData[]> {
    return this.#http
      .getData(`${this.baseUrl}/public/country/${countryId}/provinces`, { showLoader: true, showMessage: false })
      .pipe(
        map((res: any) => {
          return res.map((item: any) => ({
            id: item.id,
            firstLabel: item.provCode,
            secondLabel: item.name
          })) as DropdownData[];
        })
      );
  }

  readCitiesByProvinceId(provinceId: string): Observable<DropdownData[]> {
    return this.#http
      .getData(`${this.baseUrl}/public/province/${provinceId}/cities`, { showLoader: true, showMessage: false })
      .pipe(
        map((res: any) => {
          return res.map((item: any) => ({
            id: item.id,
            firstLabel: item.cityName,
            secondLabel: item.cityCode
          })) as DropdownData[];
        })
      );
  }

  readCitiesByCountryId(countryId: string): Observable<DropdownData[]> {
    return this.#http
      .getData(`${this.baseUrl}/public/country/${countryId}/cities`, { showLoader: true, showMessage: false })
      .pipe(
        map((res: any) => {
          return res.map((item: any) => ({
            id: item.id,
            firstLabel: item.cityName,
            secondLabel: item.cityCode
          })) as DropdownData[];
        })
      );
  }
}
